export const getTierNamesExcludingFirst = (responseData: any) => {
  const allLevels = Object.values(responseData).flat() as any[];

  const filteredLevels = allLevels.filter((level) => level.index !== 0);
  const uniqueTiers = Array.from(new Set(filteredLevels.map((l) => l.tier)));

  return uniqueTiers;
};
